export type IShiftTaskStatus = {
    id: number,
    code: ShiftTaskStatusCode,
    name: string,
    shortName?: string,
}

export enum ShiftTaskStatusCode {
    New = 'new',
    Issued = 'issued',
    Work = 'work',
    Completed = 'completed',
    Confirmed = 'confirmed',
    ConfirmedPartial = 'confirmed-partial',
    Cancelled = 'cancelled',
    Deleted = 'deleted',
}

export const ShiftTaskStatusSpec: { [key in ShiftTaskStatusCode]: Omit<IShiftTaskStatus, 'code'> } = {
    [ShiftTaskStatusCode.New]: { id: -2, name: 'Новое' },
    [ShiftTaskStatusCode.Issued]: { id: -1, name: 'Выдано' },
    [ShiftTaskStatusCode.Work]: { id: 0, name: 'В работе' },
    [ShiftTaskStatusCode.Completed]: { id: 1, name: 'На подтверждении' },
    [ShiftTaskStatusCode.Confirmed]: { id: 2, name: 'Завершено', shortName: 'Полностью' },
    [ShiftTaskStatusCode.ConfirmedPartial]: { id: 3, name: 'Завершено частично', shortName: 'Частично' },
    [ShiftTaskStatusCode.Cancelled]: { id: 80, name: 'Отменено' },
    [ShiftTaskStatusCode.Deleted]: { id: 1000, name: 'Удалено' },
}


export const ShiftTaskStatusList: IShiftTaskStatus[] = Object.keys(ShiftTaskStatusSpec).map(code => ({
    ...ShiftTaskStatusSpec[code as keyof typeof ShiftTaskStatusSpec],
    code: code as ShiftTaskStatusCode,
}));
